// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"index_toolbar_1J7tQ","user":"index_user_nYLae"};